export default __webpack_public_path__ + "static/media/uv5_kr_alph_a2.c539f507.mp3";